import { render, staticRenderFns } from "./BestBuysNow.vue?vue&type=template&id=0ad16bce"
import script from "./BestBuysNow.vue?vue&type=script&lang=js"
export * from "./BestBuysNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports